$(function () {
    // Dynamic select menus + text links
    $(document).on('click', '.dynSelAdd', function (e) {
        e.preventDefault();
        const tmpl = $(this).siblings('.selTmpl').html();
        $(this).siblings('.selItems').append(tmpl);
        updateNativeSpeakersToggle();
    });

    $(document).on('click', '.delSelItem', function (e) {
        e.preventDefault();
        $(this).parents('.selItem').remove();
        updateNativeSpeakersToggle();
        // Submit the search form
        $('.search-form').submit();
    });

    // Update native speakers toggle visibility when language selection changes
    $(document).on('change', '#search-field-languages select[name="languages[]"]', function() {
        updateNativeSpeakersToggle();
        // Submit the search form
        $('.search-form').submit();
    });

    function updateNativeSpeakersToggle() {
        const hasSelectedLanguages = $('#search-field-languages .selItems .selItem').length > 0;
        const nativeSpeakersToggle = $('label[for="search-field-native-only"]');
        
        if (hasSelectedLanguages) {
            nativeSpeakersToggle.show();
        } else {
            nativeSpeakersToggle.hide();
            // Uncheck the toggle when hidden
            $('#search-field-native-only').prop('checked', false);
        }
    }

    // Initial state
    updateNativeSpeakersToggle();
});
